import React from 'react';

import type { PluginExports } from './../ricos-types';

type PluginExportsContextProps = {
  value: Partial<PluginExports>;
};

const PluginExportsContext = React.createContext<Partial<PluginExports>>(
  {} as unknown as Partial<PluginExports>
);

export const PluginExportsContextProvider: React.FC<
  React.PropsWithChildren<PluginExportsContextProps>
> = ({ value, children }) => (
  <PluginExportsContext.Provider value={value}>{children}</PluginExportsContext.Provider>
);

export const usePluginExportsContext = () => React.useContext(PluginExportsContext);
